function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.789 82.903C64.943 82.903 82.903 64.943 82.903 42.788C82.903 20.634 64.943 2.674 42.789 2.674C20.634 2.674 2.675 20.634 2.675 42.788C2.675 64.943 20.634 82.903 42.789 82.903ZM42.789 85.577C66.42 85.577 85.577 66.42 85.577 42.788C85.577 19.157 66.42 0 42.789 0C19.157 0 0 19.157 0 42.788C0 66.42 19.157 85.577 42.789 85.577ZM25.016 46.516C24.493 45.994 24.493 45.147 25.016 44.625C25.538 44.103 26.384 44.103 26.907 44.625L36.068 53.787L58.61 31.245C59.133 30.723 59.979 30.723 60.501 31.245C61.024 31.767 61.024 32.614 60.501 33.136L37.179 56.458C37.061 56.577 36.926 56.668 36.782 56.733C36.261 57.093 35.541 57.042 35.077 56.578L25.016 46.516Z",
  fill: "#0666EB"
});

function SvgCircleCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckMark);
export default __webpack_public_path__ + "static/media/circleCheckMark.d27467f8.svg";
export { ForwardRef as ReactComponent };